import { createApp } from 'vue'
import App from '@/App.vue'
import i18n from '@/plugins/i18n'
import pinia from '@/plugins/pinia';
import router from '@/plugins/router'
import Default from '@/layouts/Default.vue';
import FullScreen from '@/layouts/FullScreen.vue';
import GenericDosageChoiceRow from '@/views/common/dosage-choices-rows/GenericDosageChoiceRow.vue';
import GenericDosageChoiceSubform from '@/views/common/dosage-choices-subforms/GenericDosageChoiceSubform.vue';
import { DateFormatter } from './utilities/date-formatter';

const app = createApp(App);

// Add plugins
app.use(pinia);
app.use(i18n);
app.use(router);

// Register layouts
app.component('default-layout', Default);
app.component('full-screen-layout', FullScreen);

// These particular components have a dependency loop and thus must be registered globally
// (otherwise a compilation error occurs when trying to include it in a dependent component)
app.component('generic-dosage-choice-subform', GenericDosageChoiceSubform);
app.component('generic-dosage-choice-row', GenericDosageChoiceRow);

// Register various globals
app.config.globalProperties.$dateFormat = new DateFormatter();

declare module "@vue/runtime-core" {
    interface ComponentCustomProperties {
        $dateFormat: DateFormatter;
    }
}

// Boot the app
app.mount('#app');
